module.exports = __webpack_public_path__ + "media/images/sp/header/station-74b5995cd53ec92e5cf2cda8b6823b52.svg";